import React from 'react';
import HeaderSeven from '../../components/Header/HeaderSeven';
import RegisterMain from './RegisterMain';
import Footer from '../../components/Footer';

const Register = () => {
  return (
    <>
      <HeaderSeven />

      <RegisterMain />

      <Footer />
    </>
  );
};

export default Register;
